const map =
[
    {
        active      : true ,
        name        : 'Qamatha' ,
        description : 'Qamatha, le créateur de toute choses chez les Xhosa en Afrique du Sud, est le fils du dieu soleil Thixo et de la déesse de la Terre Jobela. La légende raconte que lorsque Qamatha voulut créer la terre ferme au milieu des océans, le dragon de la mer Nkanyamba s’y opposa. Jobela, sa mère, créa alors quatre géants pour immobiliser Nkanyamba. Quand Qamatha jugea qu\'il avait créé assez de terre, les quatre géant furent transformés en roc pour continuer à veiller sur sa création. Il est encore possible de voir l\'un d\'entre eux, Umlindi Wemingizimu qui surplombe la ville du Cap.',
        image       : '(AFDS) Qamatha.png' ,
        geo         :
        {
            latitude  : -28.821272 ,
            longitude : 22.622356
        }
    },
    {
        active      : true ,
        name        : 'Les Valkyries' ,
        description : 'Dans la mythologie nordique, les Valkyries sont des divinités qui servent Odin, le maître des dieux. Elles accompagnent Odin dans la Chasse Sauvage à la quête de héros morts au combat, les Einherjars. C\'est sur les champs de bataille que les Valkyries choisissent les hommes les plus braves et les plus valeureux afin de les ramener à Ásgard, où Odin les attend pour les préparer à la bataille finale, le Ragnarök.',
        image       : '(AL) Valkyrie.png' ,
        geo         :
        {
            latitude  : 52.488981 ,
            longitude : 12.580509
        }
    },
    {
        active      : true ,
        name        : 'Le Kraken' ,
        description : 'Le Kraken est une créature fantastique issue des légendes scandinaves. De la taille d\'une île flottante, ce monstre est doté de nombreux tentacules comme un poulpe. D’après les légendes, le kraken serait capable de saisir la coque d\'un navire pour le faire chavirer et le tirer vers le fond de l\'océan. Selon les marins qui y ont échappé, le vrai danger, ne serait pas la créature elle-même, mais le tourbillon engendré par sa descente rapide dans l\'océan.',
        image       : '(ATL) Kraken.png' ,
        geo         :
        {
            latitude  : 37.656409 ,
            longitude : -41.007904
        }
    },
    {
        active      : true ,
        name        : 'Mami Wata' ,
        description : 'Mami Wata est une divinité aquatique du culte Africain Vaudou, souvent représentée comme une créature mi-femme mi-poisson. Selon les traditions, l\'esprit enlèverait au hasard des nageurs ou des marins pour les emmener dans son royaume paradisiaque sous l\'eau. Les voyageurs qui en réchappent reviennent souvent dans des vêtements secs, avec une nouvelle intelligence qui se reflète dans leur regard. Ils sont également plus séduisants et plus faciles à vivre',
        image       : '(ATL) Mami Wata.png' ,
        geo         :
        {
            latitude  : 7.127234 ,
            longitude :-13.799209
        }
    },
    {
        active      : true ,
        name        : 'Wagyl' ,
        description : 'Issu de la culture Noongar du sud-ouest de l’Australie, le Wagyl est une puissante divinité. Quand le Serpent arc-en-ciel, créa l\'univers et les peuples, il confia au Wagyl la création et la protection des cours d’eau. En glissant le long du terrain, le Wagyl créa les dunes de sable, le cours des fleuves et des rivières. Où il s’arrêta pour se reposer se formèrent les baies et les lacs. Il en profita également pour créer les rochers et les montagnes en souvenir de son passage. En se déplaçant, ses écailles se détachèrent pour former les forêts et les zones boisées de la région. Wagyl choisit le peuple Noongar pour protéger son oeuvre.',
        image       : '(AUS) Wagyl.png' ,
        geo         :
            {
                latitude  : -25.958569 ,
                longitude : 138.210221
            }
    },
    {
        active      : true ,
        name        : 'Amarok' ,
        description : 'Dans la mythologie inuit, Amarok représente l’esprit du loup, décrit le plus souvent comme un loup gigantesque qui dévore les chasseurs assez imprudents pour sortir chasser seuls la nuit. Contrairement aux loups qui traquent en meute, Amarok chasse seul. Sous l’influence de Kaïla, le dieu du Ciel, il vient également en aide aux humains en veillant à ce que ses frères, les loups, maintiennent les troupeaux de caribous nombreux et en bonne santé par l’élimination des animaux faibles et malades.',
        image       : '(CA) Amarok.png' ,
        geo         :
        {
            latitude  : 69.306954 ,
            longitude : -70.399746
        }
    },
    {
        active      : true ,
        name        : 'La Terre-Mère' ,
        description : 'Selon la tribu des indiens Hurons, lorsque la terre n’existait pas encore, le monde flottait, tel une île au milieu de l’océan. Une jeune femme, nommée Aataensic, partie explorer l’univers, fut sauvée par un troupeau d’oie qui la déposèrent sur le dos d’une tortue. Emue par son sort, les animaux entreprirent, à l’aide d’un peu de boue, de lui construire un monde à sa mesure. La Grande Tortue offrit de porter cette terre sur son dos. Aussi les animaux se mirent-ils à étendre la boue sur la carapace de la Grande Tortue et cette terre grandit jusqu\'à devenir une grande île, puis un continent, puis la terre que nous connaissons aujourd’hui.',
        image       : '(CAN) Terre-mère Hurons.png' ,
        geo         :
        {
            latitude  : 42.539413 ,
            longitude : -89.629032
        }
    },
    {
        active      : true ,
        name        : 'Les Haetaes' ,
        description : 'Véritable héros défenseur des palais coréens, le Haetae prend la forme d’un lion recouvert d’écailles avec une corne sur le front. Se nourrissant de feu, le Haetae fait également office d’arbitre pour juger le bien du mal. Sa capacité à discerner le mensonge de la vérité en fait un gardien efficace des palais. Les Haetaes sont généralement représentés en couple, le mâle et la femelle se font face, avec parfois des petits entre leurs pattes. Le Haetae est le symbole officielle de la ville de Séoul.',
        image       : '(CO) Haetae.png' ,
        geo         :
        {
            latitude  : 37.060210 ,
            longitude : 127.616414
        }
    },
    {
        active      : true ,
        name        : 'Les Selkies' ,
        description : 'Les selkies sont des créatures fantastiques qui parcourent les océans sous leurs formes de phoques. À la nuit tombée, ils sortent de l’eau, quittent leurs peaux de phoques pour danser sous forme humaine à la lueur de la Lune. Si par malheur un humain dérobe sa peau, le selkie en question devra lui obéir tant qu\'il ne l\'aura pas retrouvé. Si la peau n\'est pas détruite par le feu et que le selkie la retrouve, il plongera dans les profondeurs de l\'océan pour ne jamais revenir.',
        image       : '(DA) Selkies.png' ,
        geo         :
        {
            latitude  : 66.737338 ,
            longitude : 12.525781
        }
    },
    {
        active      : true ,
        name        : 'Gaïa' ,
        description : 'Gaïa est une des divinités primordiales de la mythologie grecque. Elle est considérée comme la déesse mère de tous les dieux de l’Olympe mais également comme ayant présidée à la création de toutes les races vivantes. Gaïa donna naissance à Ouranos, le Ciel, puis à Pontos, le Flot marin, et à Ouréa, les Montagnes et les Monts, ainsi qu\'aux nymphes. Gaïa est, pour les grecs, le symbole de la nature. Elle amène l’harmonie et le chaos originel nécessaire à la création de la vie.',
        image       : '(GR) Gaïa.png' ,
        geo         :
        {
            latitude  : 38.036662 ,
            longitude : 23.419264
        }
    },
    {
        active      : true ,
        name        : 'Airavata' ,
        description : 'Dans la religion hindouiste, Airavata est l’éléphant blanc qui porte le dieu Indra, le roi des dieux. C\'est un éléphant blanc gigantesque, représenté avec trois, voire 33 têtes. Un de ses noms signifie “celui qui tisse ou lie les nuages”, car un mythe affirme que cet éléphant est capable de produire des nuages. Selon la légende, Airavata serait né lorsque Brahma, le dieu créateur,  chanta les hymnes sacrés sur les moitiés de l\'œuf dont était sorti Garuda, le roi des oiseaux.',
        image       : '(IN) Airavata.png' ,
        geo         :
        {
            latitude  : 11.237277 ,
            longitude : 77.467728
        }
    },
    {
        active      : true ,
        name        : 'Enki' ,
        description : 'Dans la mythologie summérienne, Nammu, la déesse ayant présidée à la création de l’univers, due faire face à une révolte des dieux qui protestaient contre leur charge de travail. Inspirée, elle chargea son fils, Enki, secondé de sa femme Ninmah, de créer la vie sur terre. A l’aide d’argile, celui-ci créa l’homme pour seconder les dieux dans leur tâches. A chacun d’entre eux, un rôle précis fut assigné. Apaisés, les dieux cessèrent leurs protestations contre Nammu.',
        image       : '(IR) Enki.png' ,
        geo         :
        {
            latitude  : 27.291665 ,
            longitude : 54.693683
        }
    },
    {
        active      : true ,
        name        : 'Gilgamesh' ,
        description : 'Personnage mythique de la mésopotamie, Gilgamesh fut un héros popularisé lors de l’antiquité par le récit de son épopée contre Enkidu et plusieurs monstres du folklore sumérien. Capable des plus belles actions de bravoures, Gilgamesh possède également un côté sombre. Il est le roi tout puissant de la cité d’Uruk et parfois considéré comme l’un des dieux des enfers mésopotamiens.',
        image       : '(IR) Gilgamesh.png' ,
        geo         :
        {
            latitude  : 31.821196 ,
            longitude : 40.986375
        }
    },
    {
        active      : true ,
        name        : 'Amemasu' ,
        description : 'Amemasu est une créature du folklore Aïnou, une population aborigène vivant dans le Nord du Japon. Vivant dans le lac Mashū d\'Hokkaidō dont elle est la divinité gardienne, Amemasu a l’apparence d’un poisson gigantesque ou à une baleine qui serait capable de couler des bateaux, de dévorer des animaux de la taille d’un cerf, mais aussi de déclencher des tremblements de terre et autres désastres naturels.',
        image       : '(JA) Amemasu.png' ,
        geo         :
        {
            latitude  : 33.990233 ,
            longitude : 138.970875
        }
    },
    {
        active : false ,
        name   : 'Divbateau' ,
        image  : '(MED) Divbateau.png' ,
        geo    :
        {
            latitude  : 37.923707 ,
            longitude : 1.139305
        }
    },
    {
        active      : true ,
        name        : 'Le Leviathan' ,
        description : 'Le Leviathan est un monstre biblique, mais dont l’existence est bien antérieure. Créature marine titanesque qui tient du serpent, de la baleine et du crocodile, il est l’évocation d’un cataclysme qui aurait bouleversé le monde à un âge reculé. Le Leviathan est le symbole du chaos, si bien que les vagues et les tempêtes qui agitent les océans seraient le résultat de l’ondulation de sa queue.',
        image       : '(MED) Leviathan.png' ,
        geo         :
        {
            latitude  : 13.539088 ,
            longitude : 54.869143
        }
    },
    {
        active      : true ,
        name        : 'Quetzacoàl' ,
        description : 'Le Serpent à plumes est l’une des divinités des panthéons Mayas, Aztèques et Toltèques. Il fait parti des dieux qui ont participé au mythes de la création de l’homme. Selon la légende, Quetzacoàl se mit à la recherche d’os, pour compléter la première étape de la constitution d’un être vivant. À l’issu de plusieurs épreuves imposées par le dieu Mictlantecuhtli, le serpent victorieux se servit des os afin de créer les premiers êtres humains qui peuplèrent la Terre.',
        image       : '(MEX) Quetzacoàl.png' ,
        geo         :
        {
            latitude  : 18.775866 ,
            longitude : -97.178464
        }
    },
    {
        active : false ,
        name   : 'Divbateau' ,
        image  : '(OC-IN) DivBateau.png' ,
        geo    :
        {
            latitude  : -8.260014 ,
            longitude : 96.340472
        }
    },
    {
        active      : true ,
        name        : 'Kintu' ,
        description : 'Dans la tradition baganda, Kintu est le premier homme sur Terre et le père de l\'humanité. Il vivait seul dans les vastes plaines du Buganda, en Uganda, jusqu’au jour où il rencontra Nnambi, la fille de Gguli, le créateur de toutes choses. Celle-ci, descendu sur terre pour jouer avec ses frères, s\'éprit de Kintu et décida de l’épouser. Ensemble, ils eurent de nombreux enfants qui peuplèrent la Terre.',
        image       : '(OU) Kintu.png' ,
        geo         :
        {
            latitude  :  0.353926 ,
            longitude : 31.563432
        }
    },
    {
        active : false ,
        name   : 'Divbateau' ,
        image  : '(PAC) DivBateau.png' ,
        geo    :
        {
            latitude  :  17.157584 ,
            longitude : 124.112279
        }
    },
    {
        active      : true ,
        name        : 'Les Taniwha' ,
        description : 'Les Taniwha sont des créatures légendaires issues de la tradition Māori qui vivent dans les bassins d’eau profonde, les rivières, ou dans la mer. Dans certaines traditions, ils sont respectés et admirés en tant que kaitiaki, gardiens protecteurs des tribus, alors que dans d’autres, ils sont décrit comme de dangereux prédateurs qui mangent les villageois et kidnappent les femmes à la tombé de la nuit.',
        image       : '(PO) Taniwha.png' ,
        geo         :
        {
            latitude  : 20.845622 ,
            longitude : -156.911675
        }
    },
    {
        active      : true ,
        name        : 'Le Qilin' ,
        description : 'Né de la conjonction de deux étoiles et du croisement d’un dragon et d’une vache, le Qilin est une créature bienfaisante qui ne réside que dans des lieux paisibles. En voir un est un symbole de bonne augure qui vous amènera la paix, la longévité et la sérénité. Le Qilin est également un symbole de fécondité. Lors du nouvel an ou d’un mariage, les jeunes couples de l’antiquité chinoise cherchait des traces de Qilin dans le sol afin de s’assurer du bonheur de leurs futurs enfants.',
        image       : '(RPC) Qilin.png' ,
        geo         :
        {
            latitude  :  29.317352 ,
            longitude : 116.768677
        }
    },
    {
        active      : true ,
        name        : 'Ajysyt' ,
        description : 'Ajysyt est la déesse primordiale des peuples Iakoutes. Son nom signifie “qui donne naissance”. Elle est chargée de donner une âme à chaque nouveau-né et inscrire son nom dans les registres divins. Ajysyt pourvoie également à l’alimentation des hommes puisque c’est elle qui préside à la naissance des chevaux et du bétail. Selon la légende, Ajysyt vivrait au sommet d’une montagne dans une maison à sept étages, où elle écrirait le destin de chacun.',
        image       : '(RU-SIB) Ajysyt.png' ,
        geo         :
        {
            latitude  : 61.960537 ,
            longitude : 129.397142
        }
    },
    {
        active      : true ,
        name        : 'L’arbre des mondes' ,
        description : 'L’arbre des mondes représente l’univers dans les mythologies slaves. Cet arbre cosmique fait le lien entre trois mondes. Le céleste, aussi appelé les 9 mondes, le terrestre et le souterrain, le Bas monde. Il se trouve dans un endroit divin appelé Alatyr, perché sur un rocher et entouré de plusieurs rivières. Deux gardiens, Gagana, l’oiseau et Garafena, le serpent gardent l’accès au paradis, Viriï, qui se situe à la cime de l’arbre.',
        image       : '(RU) Arbre du monde.png' ,
        geo         :
        {
            latitude  : 58.564034 ,
            longitude : 34.960204
        }
    },
    {
        active      : true ,
        name        : 'Les Nâgas' ,
        description : 'Présents dans les légendes de l\'Inde et de tout le Sud-Est asiatique, les Nâgas sont des génies des eaux, représentés comme des serpents, parfois à tête humaine. Considérés comme étant de grands poètes, ces créatures semi-divine sont les habitants du monde souterrain où ils gardent jalousement les trésors de la terre. Le nâga le plus célèbre est Ananta, sur lequel se repose Vishnou, le protecteur, dans l\'intervalle entre la fin d\'un monde et la création d\'un nouveau.',
        image       : '(TH) Nâgâ.png' ,
        geo         :
        {
            latitude  : 15.000226 ,
            longitude : 101.515299
        }
    },
    {
        active      : true ,
        name        : 'Les Amazones' ,
        description : 'Les Amazones sont un peuple de femmes guerrières issu de l’union entre Arès, dieu de la guerre, et la nymphe Harmonie. Les Amazones habitent une région à l’est de la mer Noire où elles ne vivent qu’entre femmes et élèvent leurs filles pour en faire des combattantes et des chasseresses. Leur société ne laisse qu’une place secondaire aux hommes.',
        image       : '(TU) Amazone.png' ,
        geo         :
        {
            latitude  : 41.272171 ,
            longitude : 33.603919
        }
    }
];

export default map ;


// WEBPACK FOOTER //
// ./src/app/datas/map.js